export const ADMIN_PERMISSION_ACTIONS = ["view", "edit", "delete"];

export const ADMIN_PERMISSION_MODULES = [
  { key: "dashboard", label: "Dashboard" },
  { key: "course", label: "Course" },
  { key: "franchise", label: "Franchise" },
  { key: "student", label: "Student" },
  { key: "training", label: "Training" },
  { key: "front_office", label: "Front Office" },
  { key: "payment", label: "Payment" },
  { key: "account_info", label: "Account Info" },
  { key: "exam", label: "Exam" },
  { key: "certification", label: "Certification" },
  { key: "settings", label: "Settings" },
  { key: "message", label: "Message" },
];

const ROUTE_MODULES = [
  { prefix: "/dashboard/course", module: "course" },
  { prefix: "/dashboard/new-module", module: "course" },
  { prefix: "/dashboard/view-module", module: "course" },
  { prefix: "/dashboard/new-course", module: "course" },
  { prefix: "/dashboard/view-course", module: "course" },
  { prefix: "/dashboard/add-category", module: "course" },
  { prefix: "/dashboard/view-category", module: "course" },
  { prefix: "/dashboard/franchise-training", module: "training" },
  { prefix: "/dashboard/franchise", module: "franchise" },
  { prefix: "/dashboard/new-franchise", module: "franchise" },
  { prefix: "/dashboard/view-franchise", module: "franchise" },
  { prefix: "/dashboard/hold-reject-franchise", module: "franchise" },
  { prefix: "/dashboard/blacklisted-franchise", module: "franchise" },
  { prefix: "/dashboard/total-franchise", module: "franchise" },
  { prefix: "/dashboard/student", module: "student" },
  { prefix: "/dashboard/view-application", module: "student" },
  { prefix: "/dashboard/view-student", module: "student" },
  { prefix: "/dashboard/exam-complete", module: "student" },
  { prefix: "/dashboard/our-student", module: "student" },
  { prefix: "/dashboard/certified-student", module: "student" },
  { prefix: "/dashboard/postal", module: "front_office" },
  { prefix: "/dashboard/payout", module: "payment" },
  { prefix: "/dashboard/deposit", module: "payment" },
  { prefix: "/dashboard/view-deposit", module: "payment" },
  { prefix: "/dashboard/reject-transaction", module: "payment" },
  { prefix: "/dashboard/payment-account-setting", module: "payment" },
  { prefix: "/dashboard/deduct", module: "payment" },
  { prefix: "/dashboard/view-deduct", module: "payment" },
  { prefix: "/dashboard/online-payment", module: "payment" },
  { prefix: "/dashboard/statement", module: "account_info" },
  { prefix: "/dashboard/new-exam", module: "exam" },
  { prefix: "/dashboard/view-exam", module: "exam" },
  { prefix: "/dashboard/new-mcq", module: "exam" },
  { prefix: "/dashboard/view-mcq", module: "exam" },
  { prefix: "/dashboard/csv-upload", module: "exam" },
  { prefix: "/dashboard/exam-result", module: "exam" },
  { prefix: "/dashboard/marksheet", module: "certification" },
  { prefix: "/dashboard/certificate", module: "certification" },
  { prefix: "/dashboard/new-grade", module: "certification" },
  { prefix: "/dashboard/amci-design", module: "certification" },
  { prefix: "/dashboard/franchise-affiliated-cert-design", module: "franchise" },
  { prefix: "/dashboard/home-setting", module: "settings" },
  { prefix: "/dashboard/about-setting", module: "settings" },
  { prefix: "/dashboard/session-control", module: "settings" },
  { prefix: "/dashboard/franchise-tc", module: "settings" },
  { prefix: "/dashboard/download-setting", module: "settings" },
  { prefix: "/dashboard/gallery", module: "settings" },
  { prefix: "/dashboard/topbar-footer-setting", module: "settings" },
  { prefix: "/dashboard/contact", module: "message" },
  { prefix: "/dashboard/state", module: "settings" },
  { prefix: "/dashboard/district", module: "settings" },
  { prefix: "/dashboard/admin-users", module: "settings" },
  { prefix: "/dashboard/policy-setting", module: "settings" },
  { prefix: "/dashboard/new-message", module: "message" },
  { prefix: "/dashboard/notification-panel", module: "message" },
  { prefix: "/dashboard/view-message", module: "message" },
  { prefix: "/dashboard/message-request", module: "message" },
  { prefix: "/dashboard/ticket-system", module: "message" },
  { prefix: "/dashboard/notification-settings", module: "settings" },
];

export const getStoredAdminUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    return null;
  }
};

export const isMasterAdmin = (user = getStoredAdminUser()) => user?.role === "master_admin";

export const getRouteModule = (pathname) => {
  if (pathname === "/dashboard") return "dashboard";
  return ROUTE_MODULES.find((item) => pathname.startsWith(item.prefix))?.module || "dashboard";
};

export const hasAdminPermission = (moduleKey, action = "view", user = getStoredAdminUser()) => {
  if (!user) return false;
  if (isMasterAdmin(user)) return true;
  return Boolean(user.permissions?.[moduleKey]?.[action]);
};
